import { HttpClient, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ProductDealsService {
  private baseUrl: string = "/deal-product";
  constructor(private _httpClient: HttpClient) {}

  async getDeals() {
    return this._httpClient
      .get(`${this.baseUrl}`)
      .toPromise()
      .then((deals: any) => {
        return deals.map((deal: any) => {
          if (Array.isArray(deal.description)) {
            deal.description = deal.description.filter((i: any) => i);
          }
          return deal;
        });
      });
  }

  //singola offerta
  async getDeal(id: number) {
    return this._httpClient.get(`${this.baseUrl}/${id}`).toPromise();
  }

  async addDeal(data: any = {}) {
    return this._httpClient.post(`${this.baseUrl}`, data).toPromise();
  }

  async editDeal(id: number, data: any = {}) {
    return this._httpClient.put(`${this.baseUrl}/${id}`, data).toPromise();
  }

  async deleteDeal(id: number) {
    return this._httpClient.delete(`${this.baseUrl}/${id}`).toPromise();
  }

  async generateDealDocument(id: number) {
    return this._httpClient.post(`${this.baseUrl}/document/generate/${id}`, {}).toPromise();
  }

  async uploadDocument(file: any, id: number) {
    const formData: FormData = new FormData();
    formData.append("file", file);
    const req: any = new HttpRequest("PUT", `${this.baseUrl}/document/upload/${id}`, formData);
    return this._httpClient.request(req).toPromise();
  }
}
